import { MessageInfoModel, MessageUnreadInfoModel } from 'services/types/Message'
import { AccountAssets } from 'services/types/User'
import { AppState } from 'state'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { setProfileInfo } from './actions'
import { updateAvatar, updateUserName, updateUserAssets, updateProcessing, updateCabitalCurrency } from './reducer'

export function useProfileInfo() {
  const dispatch = useAppDispatch()
  return dispatch(setProfileInfo())
}

export function useUser() {
  return useAppSelector((state: AppState) => state.user.userInfo)
}

export function useUserCabitalBalance() {
  return useAppSelector((state: AppState) => state.user.userCabitalBalance)
}

export function useCabitalCurrency() {
  return useAppSelector((state: AppState) => state.user.cabitalCurrency)
}

export function useCabitalInfo() {
  return useAppSelector((state: AppState) => state.user.cabitalInfo)
}

export function useUserAssets() {
  return useAppSelector((state: AppState) => state.user.assets)
}
export function useUserCoinAssets() {
  return useAppSelector((state: AppState) => state.user.assets.coinMsgList)
}

export function useUserProcessing() {
  return useAppSelector((state: AppState) => state.user.processing)
}

export function useUpdateUserName(data: string) {
  const dispatch = useAppDispatch()
  return dispatch(updateUserName(data))
}

export function useUpdateProcessing(data: number) {
  const dispatch = useAppDispatch()
  return dispatch(updateProcessing(data))
}

export function useUpdateCabitalCurrency(data: string) {
  const dispatch = useAppDispatch()
  return dispatch(updateCabitalCurrency(data))
}

export function useUpdateAvatar(data: string) {
  const dispatch = useAppDispatch()
  return dispatch(updateAvatar(data))
}

export function useUpdateUserAssets(data: AccountAssets) {
  const dispatch = useAppDispatch()
  return dispatch(updateUserAssets(data))
}

export function usePublicKey(): string {
  return useAppSelector((state: AppState) => state.user.publicKey)
}

export function useRefreshNftType(): string {
  return useAppSelector((state: AppState) => state.user.refreshNftType)
}

export function useMessageInfo(): MessageInfoModel {
  return useAppSelector((state: AppState) => state.user.messageInfo)
}

export function useMessageUnReadInfo(): MessageUnreadInfoModel {
  return useAppSelector((state: AppState) => state.user.messageUnreadInfo)
}
